import { useEffect, useState } from 'react';
// @mui
import {
  Dialog,
  Container,
  Stack,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
// components
import SvgIconStyle from '../../components/SvgIconStyle';
import Iconify from '../../components/Iconify';
import {
  ContentCard,
  CandidateCardList,
} from './matching';
import {
  JobPostStatusChip,
} from './';
import {
  StopDialog,
  ResumeDialog,
} from './stop';
// hooks
import useResponsive from '../../hooks/useResponsive';
import useIsMountedRef from '../../hooks/useIsMountedRef';


// ------------------------------------------------------------

export default function JobPostMatchingDialog({
  isOpen,
  jobPost,
  candidateId,
  editJobPost,
  closeDialog,
  openJobPostOfferDialog,
  reloadJobs,
}) {
  const smUp = useResponsive('up', 'sm');
  const isMountedRef = useIsMountedRef();

  const [openStopDialog, setOpenStopDialog] = useState(false);
  const [resumeOpen, setResumeOpen] = useState(false);

  const resumeJobPost = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setResumeOpen(true);
  };

  const closeResumeDialog = () => {
    if (isMountedRef.current) {
      setResumeOpen(false);
    }
  }

  return (
    <Dialog fullScreen open={isOpen} onClose={closeDialog} transitionDuration={0}>
      {/* 버튼 */}
      <Stack direction="row" alignItems="center" justifyContent="flex-end">
        <IconButton onClick={closeDialog} sx={{ mr: 2, mt: 2 }}>
          <Iconify icon="eva:close-fill" sx={{ width: 32 , height: 32, color: (theme) => theme.palette.text.primary }} />
        </IconButton>
      </Stack>
      <Container maxWidth="laptop" sx={{ px: 3, mb: 15 }}>

        {/* 포지션 타이틀 */}
        <Stack sx={{ mb: 4 }}>
          <Stack direction="row" alignItems={"center"} spacing={1}>
            <Typography variant="h3">
              {jobPost?.get_position_display}
            </Typography>
            <JobPostStatusChip status={jobPost?.status} />
          </Stack>
          {jobPost?.status === "stop" && (
            <Button
              size={smUp ? "medium" : "small"}
              sx={{
                color: "text.disabled",
                fontWeight: 'bold',
                width: "fit-content",
                mt: 1,
              }}
              onClick={resumeJobPost}
              startIcon={<Iconify icon={'eva:alert-circle-fill'} />}
            >
              이 공고로 다시 매칭받고 싶으신가요?
            </Button>
          )}
        </Stack>

        {/* 매칭 크루 */}
        <CandidateCardList jobPost={jobPost} openJobPostOfferDialog={openJobPostOfferDialog} candidateId={candidateId} />

        {/* 공고 내용 */}
        <Stack spacing={2} direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            <SvgIconStyle src="/icons/icon-document-mono.svg" sx={{ width: 18, height: 18, color: "text.secondary" }} />
            <Typography variant="subtitle1">
              작성한 공고
            </Typography>
          </Stack>
          {/* 매칭 종료일때는 안보이기 */}
          {!["stop"].includes(jobPost?.status) && (
          <Button
            variant="outlined"
            size="small"
            color="inherit"
            sx={{
              color: "text.secondary",
            }}
            startIcon={<SvgIconStyle src="/icons/icon-pencil-mono.svg" sx={{ width: 18, height: 18, color: "text.secondary" }} />}
            onClick={() => editJobPost(jobPost)}
          >
            수정하기
          </Button>
          )}
        </Stack>

        {/* Content */}
        <ContentCard jobPost={jobPost} />

        {jobPost?.can_stop && (
          <Button
            type="button"
            size={smUp ? "medium" : "small"}
            sx={{
              mt: 2,
              color: (theme) => theme.palette.grey[500],
              fontWeight: 'bold',
            }}
            onClick={() => setOpenStopDialog(true)}
            startIcon={<Iconify icon={'eva:alert-circle-fill'} />}
          >
            혹시 이 공고를 멈추고 싶으신가요?
          </Button>
        )}
      </Container>

      <StopDialog
        jobPost={jobPost}
        isOpen={openStopDialog}
        reloadJobs={() => reloadJobs(jobPost?.id)}
        closeDialog={() => { setOpenStopDialog(false)} }
      />
      <ResumeDialog
        isOpen={resumeOpen}
        closeDialog={closeResumeDialog}
        jobPostId={jobPost?.id}
        reloadJobs={reloadJobs}
      />
    </Dialog>
  )
};
